// extracted by mini-css-extract-plugin
export default {"page_not_found":"PageNotFound_page_not_found__B6zmN"};